
import { PixelScriptMetadata } from "../../UpdatePixelScript";
import { ScriptFormatter } from "./ScriptFormatter";
import { ScriptDisplay } from "./ScriptDisplay";

interface PrivacyOptionsProps {
  pixelId: string;
  scriptMetadata: PixelScriptMetadata | null;
}

export function PrivacyOptions({ pixelId, scriptMetadata }: PrivacyOptionsProps) {
  const disabledScript = ScriptFormatter.getDisabledTrackingScript(pixelId, scriptMetadata);
  
  return (
    <div className="mt-6 border-t pt-4">
      <h3 className="text-sm font-medium">Privacy Options</h3>
      <div className="mt-2 text-sm text-muted-foreground">
        <p className="mb-2">This tracking pixel respects the following privacy options:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Browser's "Do Not Track" setting</li>
          <li>Opt-out cookies (<code>opt_out_tracking=true</code>)</li>
          <li>URL parameters (<code>?no_track=true</code>)</li>
          <li>Global configuration object (<code>window.pixelConfig.enabled = false</code>)</li>
          <li>Script attribute (<code>data-tracking="disabled"</code>)</li>
        </ul>
      </div>
      
      <div className="mt-4">
        <h4 className="text-sm font-medium">Disabled Tracking Code Example:</h4>
        <ScriptDisplay script={disabledScript} />
      </div>
      
      <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-md">
        <h4 className="text-sm font-medium text-amber-800">Security Information</h4>
        <p className="text-sm text-amber-700 mt-1">
          This script includes integrity protection to prevent tampering. The script is served from a secure location and its contents are verified by your browser.
        </p>
      </div>
    </div>
  );
}
